import type {Conversation, InteractionID, Message} from "@khan/guide-types";

/**
 * Returns the last incoming message in the provided conversation with a
 * matching interaction ID.
 */
export const getLastIncomingMessageById = (
    conversation: Conversation,
    interactionId: InteractionID,
): Message | null => {
    return (
        conversation.findLast(
            (m) => m.type === "incoming" && m.interactionId === interactionId,
        ) ?? null
    );
};
